var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-drawer-logo"},[_c('img',{staticClass:"logo",attrs:{"height":"34px","src":("/logo" + (_vm.envs.includes(_vm.env) ? '-' + _vm.env : '') + ".svg"),"alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }